/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createFeedback } from '../fn/feedbacks/create-feedback';
import { CreateFeedback$Params } from '../fn/feedbacks/create-feedback';
import { Feedback } from '../models/feedback';
import { FeedbackResponsePage } from '../models/feedback-response-page';
import { listFeedbacks } from '../fn/feedbacks/list-feedbacks';
import { ListFeedbacks$Params } from '../fn/feedbacks/list-feedbacks';
import { updateFeedback } from '../fn/feedbacks/update-feedback';
import { UpdateFeedback$Params } from '../fn/feedbacks/update-feedback';

@Injectable({ providedIn: 'root' })
export class FeedbacksApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listFeedbacks()` */
  static readonly ListFeedbacksPath = '/v0/feedbacks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listFeedbacks()` instead.
   *
   * This method doesn't expect any request body.
   */
  listFeedbacks$Response(params?: ListFeedbacks$Params, context?: HttpContext): Observable<StrictHttpResponse<FeedbackResponsePage>> {
    return listFeedbacks(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listFeedbacks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listFeedbacks(params?: ListFeedbacks$Params, context?: HttpContext): Observable<FeedbackResponsePage> {
    return this.listFeedbacks$Response(params, context).pipe(
      map((r: StrictHttpResponse<FeedbackResponsePage>): FeedbackResponsePage => r.body)
    );
  }

  /** Path part for operation `createFeedback()` */
  static readonly CreateFeedbackPath = '/v0/feedbacks';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFeedback()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFeedback$Response(params: CreateFeedback$Params, context?: HttpContext): Observable<StrictHttpResponse<Feedback>> {
    return createFeedback(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createFeedback$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFeedback(params: CreateFeedback$Params, context?: HttpContext): Observable<Feedback> {
    return this.createFeedback$Response(params, context).pipe(
      map((r: StrictHttpResponse<Feedback>): Feedback => r.body)
    );
  }

  /** Path part for operation `updateFeedback()` */
  static readonly UpdateFeedbackPath = '/v0/feedbacks/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFeedback()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFeedback$Response(params: UpdateFeedback$Params, context?: HttpContext): Observable<StrictHttpResponse<Feedback>> {
    return updateFeedback(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFeedback$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFeedback(params: UpdateFeedback$Params, context?: HttpContext): Observable<Feedback> {
    return this.updateFeedback$Response(params, context).pipe(
      map((r: StrictHttpResponse<Feedback>): Feedback => r.body)
    );
  }

}
